import React from 'react'
import { Link } from 'react-router-dom'

function ListaArticulos({ articles }) {
  return (
    <div className="article-list">
        {articles.map(article => (
            <div className="article-container" key={article.id}>
                <div className="img-container">
                    <Link to={article.route}>
                        <img src={article.image} alt={article.title} />
                    </Link>
                </div>
                <div className="article-body">
                    <h2>{article.title}</h2>
                    <p>{article.description}</p>
                    <div className="article-footer">
                        <span>{article.date} · </span>
                        <span>{article.ReadingTime}</span>
                    </div>
                </div>
            </div>
        ))}
    </div>
  )
}

export default ListaArticulos